import { render, staticRenderFns } from "./yszc.vue?vue&type=template&id=d146e888&scoped=true"
import script from "./yszc.vue?vue&type=script&lang=js"
export * from "./yszc.vue?vue&type=script&lang=js"
import style0 from "./yszc.vue?vue&type=style&index=0&id=d146e888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d146e888",
  null
  
)

export default component.exports